// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s_kos_page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Header ── */
.s_kos_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-top: 6px;
}

.s_kos_title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.s_kos_header-icon {
  width: 28px;
  height: 28px;
  color: #0860e6;
  flex-shrink: 0;
}

.s_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

.s_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Tabs ── */
.s_kos_tabs {
  display: flex;
  border-bottom: 1px solid #e6e6e6;
}

.s_kos_tab {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  background: transparent;
  color: #6b6b6b;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  font-family: inherit;
}

.s_kos_tab-active {
  color: #0860e6;
  border-bottom-color: #0860e6;
  font-weight: 600;
}

/* ── Sections ── */
.s_kos_sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.s_kos_section {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
}

/* ── Section Header ── */
.s_kos_section-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 20px 16px 20px;
}

.s_kos_section-icon {
  width: 36px;
  height: 36px;
  background: #eff5ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.s_kos_section-icon svg {
  width: 18px;
  height: 18px;
  color: #0860e6;
}

.s_kos_section-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 3px 0;
}

.s_kos_section-sub {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Section Body ── */
.s_kos_section-body {
  padding: 4px 20px 20px 20px;
  border-top: 1px solid #f0f0f0;
}

/* ── Two-column grid ── */
.s_kos_two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
}

/* ── Field ── */
.s_kos_field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.s_kos_label {
  font-size: 13px;
  font-weight: 500;
  color: #4b4b4b;
}

/* ── Input ── */
.s_kos_input {
  height: 38px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13px;
  color: #0b0b0b;
  background: #fff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}

.s_kos_input:focus {
  border-color: #0860e6;
}

/* ── Note text ── */
.s_kos_note {
  font-size: 13px;
  color: #0860e6;
  margin: 10px 0 0 0;
}

/* ── Toggle row ── */
.s_kos_toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  margin-top: 16px;
  background: #fafafa;
}

.s_kos_toggle-title {
  font-size: 13px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 2px 0;
}

.s_kos_toggle-sub {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Preparation Slots header ── */
.s_kos_slots-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
}

.s_kos_slots-header .s_kos_section-header {
  padding: 0;
}

/* ── Slot list ── */
.s_kos_slot-list {
  border-top: 1px solid #f0f0f0;
  padding: 12px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.s_kos_slot-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: #fafafa;
  border: 1px solid #ebebeb;
  border-radius: 10px;
}

.s_kos_slot-icon-wrap {
  width: 40px;
  height: 40px;
  background: #eff5ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.s_kos_slot-icon-wrap svg {
  width: 20px;
  height: 20px;
  color: #0860e6;
}

.s_kos_slot-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.s_kos_slot-name {
  font-size: 14px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0;
}

.s_kos_slot-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.s_kos_slot-time {
  font-size: 13px;
  color: #6b6b6b;
  background: #f0f0f0;
  padding: 2px 8px;
  border-radius: 20px;
}

.s_kos_slot-category {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #6b6b6b;
}

.s_kos_slot-category svg {
  width: 14px;
  height: 14px;
  color: #949494;
}

/* ── Slot action buttons (shown on hover) ── */
.s_kos_slot-actions {
  margin-left: auto;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s;
  flex-shrink: 0;
}

.s_kos_slot-item:hover .s_kos_slot-actions {
  opacity: 1;
}

.s_kos_slot-action-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b6b6b;
  transition: background 0.15s, color 0.15s;
  padding: 0;
}

.s_kos_slot-action-btn svg {
  width: 16px;
  height: 16px;
}

.s_kos_slot-action-btn:hover {
  background: #f0f0f0;
  color: #0b0b0b;
}

.s_kos_slot-action-delete:hover {
  background: #fef2f2;
  color: #e90000;
}

/* ── Modal ── */
.s_kos_modal-sub {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0 0 18px;
}

.s_kos_modal-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.s_kos_modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/settings-kitchenOS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV","sourcesContent":[".s_kos_page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Header ── */\n.s_kos_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding-top: 6px;\n}\n\n.s_kos_title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.s_kos_header-icon {\n  width: 28px;\n  height: 28px;\n  color: #0860e6;\n  flex-shrink: 0;\n}\n\n.s_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.s_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Tabs ── */\n.s_kos_tabs {\n  display: flex;\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.s_kos_tab {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  background: transparent;\n  color: #6b6b6b;\n  transition: color 0.15s, border-color 0.15s;\n  margin-bottom: -1px;\n  font-family: inherit;\n}\n\n.s_kos_tab-active {\n  color: #0860e6;\n  border-bottom-color: #0860e6;\n  font-weight: 600;\n}\n\n/* ── Sections ── */\n.s_kos_sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.s_kos_section {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 12px;\n}\n\n/* ── Section Header ── */\n.s_kos_section-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 20px 16px 20px;\n}\n\n.s_kos_section-icon {\n  width: 36px;\n  height: 36px;\n  background: #eff5ff;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.s_kos_section-icon svg {\n  width: 18px;\n  height: 18px;\n  color: #0860e6;\n}\n\n.s_kos_section-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 3px 0;\n}\n\n.s_kos_section-sub {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Section Body ── */\n.s_kos_section-body {\n  padding: 4px 20px 20px 20px;\n  border-top: 1px solid #f0f0f0;\n}\n\n/* ── Two-column grid ── */\n.s_kos_two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n/* ── Field ── */\n.s_kos_field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.s_kos_label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #4b4b4b;\n}\n\n/* ── Input ── */\n.s_kos_input {\n  height: 38px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #0b0b0b;\n  background: #fff;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.s_kos_input:focus {\n  border-color: #0860e6;\n}\n\n/* ── Note text ── */\n.s_kos_note {\n  font-size: 13px;\n  color: #0860e6;\n  margin: 10px 0 0 0;\n}\n\n/* ── Toggle row ── */\n.s_kos_toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  margin-top: 16px;\n  background: #fafafa;\n}\n\n.s_kos_toggle-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 2px 0;\n}\n\n.s_kos_toggle-sub {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Preparation Slots header ── */\n.s_kos_slots-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 20px 20px 16px 20px;\n}\n\n.s_kos_slots-header .s_kos_section-header {\n  padding: 0;\n}\n\n/* ── Slot list ── */\n.s_kos_slot-list {\n  border-top: 1px solid #f0f0f0;\n  padding: 12px 20px 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.s_kos_slot-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  background: #fafafa;\n  border: 1px solid #ebebeb;\n  border-radius: 10px;\n}\n\n.s_kos_slot-icon-wrap {\n  width: 40px;\n  height: 40px;\n  background: #eff5ff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.s_kos_slot-icon-wrap svg {\n  width: 20px;\n  height: 20px;\n  color: #0860e6;\n}\n\n.s_kos_slot-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.s_kos_slot-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.s_kos_slot-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.s_kos_slot-time {\n  font-size: 13px;\n  color: #6b6b6b;\n  background: #f0f0f0;\n  padding: 2px 8px;\n  border-radius: 20px;\n}\n\n.s_kos_slot-category {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: #6b6b6b;\n}\n\n.s_kos_slot-category svg {\n  width: 14px;\n  height: 14px;\n  color: #949494;\n}\n\n/* ── Slot action buttons (shown on hover) ── */\n.s_kos_slot-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.15s;\n  flex-shrink: 0;\n}\n\n.s_kos_slot-item:hover .s_kos_slot-actions {\n  opacity: 1;\n}\n\n.s_kos_slot-action-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b6b6b;\n  transition: background 0.15s, color 0.15s;\n  padding: 0;\n}\n\n.s_kos_slot-action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.s_kos_slot-action-btn:hover {\n  background: #f0f0f0;\n  color: #0b0b0b;\n}\n\n.s_kos_slot-action-delete:hover {\n  background: #fef2f2;\n  color: #e90000;\n}\n\n/* ── Modal ── */\n.s_kos_modal-sub {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0 0 18px;\n}\n\n.s_kos_modal-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.s_kos_modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
